import React, { useState, useEffect } from "react";
import GetUserProfileInfo from "../helpers/getUserProfileInfo";
import { successAlert } from '../utils/toastifyAlerts'


const UserData = () => {
  const [data, setData] = useState('');

  useEffect(() => {
    async function fetchData() {
      const resp = await GetUserProfileInfo()
      setData(resp)
    }
    fetchData()
  }, [])

  function copy(text) {
    navigator.clipboard.writeText(text)
    successAlert(`${text} copied to clipboard`)
  }

  return (
      <div className='profileSCV' data-test="profile">
        <h3 data-test="userName" onClick={() => copy(data.username)}>{data && data.username}</h3>
        <h6 data-test="userEmail" onClick={() => copy(data.email)}>{data && data.email}</h6>
        <h6 data-test="userId" onClick={() => copy(data.id)}>{data && data.id}</h6>
      </div>
  );
}

export default UserData
